<template>
  <div class="auth-page">
    <div class="auth-card">
      <h1>Восстановление пароля</h1>
      <form @submit.prevent="submit">
        <div class="form-field">
          <label for="email">Email</label>
          <input id="email" v-model="email" type="email" autocomplete="email" required />
        </div>
        <p v-if="message" class="success-message">{{ message }}</p>
        <p v-if="error" class="error-message">{{ error }}</p>
        <button class="btn" type="submit" :disabled="loading">
          {{ loading ? 'Отправка...' : 'Отправить ссылку' }}
        </button>
      </form>
      <p style="margin-top: 1rem">
        <router-link to="/login">Вернуться ко входу</router-link>
      </p>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useAuthStore } from '../stores/auth'

const auth = useAuthStore()

const email = ref('')
const loading = ref(false)
const error = ref('')
const message = ref('')

async function submit() {
  loading.value = true
  error.value = ''
  message.value = ''

  try {
    const result = await auth.requestPasswordReset(email.value)
    message.value = result.message
  } catch (err) {
    error.value = err.response?.data?.error || 'Не удалось отправить письмо'
  } finally {
    loading.value = false
  }
}
</script>
